import { useTranslation } from "react-i18next";

const RoleLabel = ({ roles }) => {
  const { t } = useTranslation();

  return (
    <span
      className={`text-white text-xs px-3 rounded py-1 ${
        roles.includes("ROLE_ADMIN")
          ? "bg-red-600"
          : roles.includes("ROLE_CONTRIBUTOR")
          ? "bg-bioport-orange"
          : "bg-bioport-blue"
      }`}
    >
      {t(`roles.${roles[0].toLowerCase()}`)}
    </span>
  );
};

export default RoleLabel;
